// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '../_common/form/Icon';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import { currency } from '../_common/api/utility';

const Wrapper = styled(Link)`
    flex: 1;
    min-height: ${({ solo }) => solo ? '6rem' : '11.2rem'};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: ${({ solo }) => solo ? 'stretch' : 'center'};
    justify-content: ${({ solo }) => solo ? 'center' : 'flex-start'};
    gap: 1.1rem;
    text-decoration: none;
    border-radius: 1rem;
    padding: 1rem 0.9rem 0.9rem 0.9rem;
    color: ${({ theme }) => theme.mobile.loyaltyCard.compactText || '#ffffff'};
    background: ${({ theme }) => theme.mobile.loyaltyCard.compactBackground || '#66c887'};
    box-shadow: 1px 1px 5px 1px ${({ theme }) => theme.mobile.shadow};
    text-align: ${({ solo }) => solo ? 'left' : 'center'};

    &:active {
        opacity: 0.8;
    }
`

const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    font-weight: 700;
    font-size: 1.1rem;
`

const Balance = styled.div`
    font-size: 2.2rem;
    font-weight: 800;
    color: ${({ theme }) => theme.mobile.loyaltyCard.compactAccent || '#f6f04f'};
    line-height: 1;
    text-align: center;
    margin-top: auto;
`

const GuestText = styled.div`
    margin-top: ${({ solo }) => solo ? '0' : 'auto'};
    font-size: ${({ solo }) => solo ? '1.05rem' : '0.95rem'};
    font-weight: 700;
    line-height: 1.15;
    max-width: ${({ solo }) => solo ? 'none' : '10rem'};
`

const SoloRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    width: 100%;
`

const SoloIcon = styled(Icon)`
    font-size: 1.5rem;
`

const GiftBalanceCard = ({ ...props }) => {
    const {
        state: {
            active_user,
            site_config
        }
    } = useGlobalState();

    const giftBalance = active_user?.account?.giftBalance ?? active_user?.account?.value?.giftBalance;
    const balanceLoaded = typeof giftBalance === 'number';
    const widgetText = site_config.homeWidgetText || {};

    return (
        <Wrapper to={props.guest ? '/giftCards' : '/wallet'} solo={props.solo ? 1 : 0}>
            {props.solo ?
                <SoloRow>
                    <SoloIcon icon='gift' />
                    <GuestText solo={1}>{widgetText.giftGuestMessage || 'SIGN UP TO USE OUR APP CREDIT!'}</GuestText>
                </SoloRow>
                :
                <>
                    <Header>
                        <Icon icon='gift' />
                        <span>{props.guest ? (widgetText.giftGuestTitle || 'App Credit') : (widgetText.giftSignedInTitle || 'My App Credit Balance')}</span>
                    </Header>
                    {props.guest ?
                        <GuestText>{widgetText.giftGuestMessage || 'SIGN UP TO USE OUR APP CREDIT!'}</GuestText>
                        : balanceLoaded ? <Balance>{currency.format(giftBalance)}</Balance> : null}
                </>
            }
        </Wrapper>
    );
}

export default GiftBalanceCard;
